<template>
	<div class="user-watches-devices-grid">
		<div v-for="group in groups.data" :key="group.id" class="group">
			<div class="group-name">{{ group.name }}</div>
			<div class="group-container">
				<div class="idi-grid watches">
					<device v-for="watch in group.elements" :key="watch.id" :user_uid="user_uid" :watch="watch" class="watch"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Device from './UserWatchesDevicesGridDevice'
export default {
	props: [
		'user_uid',
		'groups'
	],
	components: {
		Device
	},
	computed: {
		canRegistWatch () {
			return true
			return this.$store.getters.canRegistWatch
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/watches/UserWatchesDevicesGrid.vue